import React, { useState, useCallback, useRef } from 'react'
import { ReactTitle } from '../utils/MetaTags'
import { useTranslation } from 'react-i18next'
import { sortBy } from 'lodash'
import { withRouter } from 'react-router'
import ConversationsApi from '../../api/ConversationsApi'
import { capitalize } from '../../decorators/textTools'
import InfiniteLocationList from '../shared/InfiniteLocationList'
import ConversationFilters from './ConversationFilters'

export function ConversationsPage() {
  const { t } = useTranslation()
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)
  const [coordinates, setCoordinates] = useState('')
  const [venueType, setVenueType] = useState('')
  const loadingRef = useRef(false)
  const pageCountRef = useRef(1)

  const handleLocationChange = useCallback((value, fieldName) => {
    if (fieldName === 'coordinates') {
      setCoordinates(value)
      setItems([])
      pageCountRef.current = 1
    }
  }, [])

  const handleVenueTypeChange = useCallback((value) => {
    setVenueType(value)
    setItems([])
    pageCountRef.current = 1
  }, [])

  const onLoadMore = useCallback((offset, limit) => {
    if (loadingRef.current) return
    loadingRef.current = true
    setLoading(true)

    ConversationsApi.getAll({ limit, offset, coordinates, venueType })
      .then((res) => {
        if (!res.response?.ok) return
        const newConversations = res.json || []
        setItems((prev) => {
          const existingIds = new Set(prev.map((c) => c.id))
          const unique = newConversations.filter((c) => !existingIds.has(c.id))
          const merged = [...prev, ...unique]
          return sortBy(merged, [(o) => o.startsAt])
        })
        pageCountRef.current += 1
      })
      .finally(() => {
        loadingRef.current = false
        setLoading(false)
      })
  }, [coordinates, venueType])

  return (
    <div>
      <ReactTitle title={`${capitalize(global.siteTitle)} - ${t('meta.allConversations')}`} />

      <InfiniteLocationList
        limit={9}
        onLoadMore={onLoadMore}
        items={items}
        itemsLoading={loading}
        itemType='conversation'
        header={global.coco ? t('user.upcomingTopics') : t('common.findConversation')}
        transparentHeader
        filters={ConversationFilters}
        filtersProps={{
          onLocationChange: handleLocationChange,
          onVenueTypeChange: handleVenueTypeChange,
          venueType
        }}
      />
    </div>
  )
}

export default withRouter(ConversationsPage)
